import React, { useEffect, useState } from 'react';
import CartIcon from '../../icons/cart';
import { Link } from 'react-router-dom';
import AddToCart from '../AddToCart';
import BookCarousel from '../BookCarousel';


export default function BookPage() {

  document.title = `1969 by Eileen Myles | Hanuman Editions`;
  document.querySelector('meta[name="description"]').setAttribute('content', `Published as a companion piece to their debut story collection, Bread and Water, 1969 recounts with wry exuberance a year in the emotional life of the poet Eileen Myles, or their canny stand-in, at the louche age of nineteen turning twenty. Writing of early boyfriends, witnessing Woodstock, porch times and Boston bars, Myles presents a portrait of personal aspiration and dissolution at the peak of American counterculture and global revolution.
`);

  return (<div className='newPageContainer'>
    <div className='productContainer'>
      <div className='productImage_container  '>
        <div className='productCarousel'>
          <BookCarousel images={['../../Series-Special/1969_Back.png', '../../Series-Special/1969_Side_v2.png', '../../Series-Special/1969_Front_v2.png']} start={1} />
        </div>
      </div>
      <div className='productInfo_container'>
        <div className='productInfo_inner'>
          <div className='productInfo'>
            <h1 className='productTitle'>1969</h1>
            <div className='productAuthor'>Eileen Myles</div>
          </div>
          <div className='productBuyControls'>
            <AddToCart context={'product'} id={'9798995641001'} />
            <div className='productPrice'>$16.99 USD</div>
          </div>

          <div className='productDescription'>Published as a companion piece to their debut story collection, <em>Bread and Water</em>, <em>1969</em> recounts with wry exuberance a year in the emotional life of the poet Eileen Myles, or their canny stand-in, at the louche age of nineteen turning twenty. Writing of early boyfriends, witnessing Woodstock, porch times and Boston bars, Myles presents a portrait of personal aspiration and dissolution at the peak of American counterculture and global revolution.
          </div>
          <div className='productDescription'>
            <p>The poet, novelist and former presidential candidate <strong>Eileen Myles</strong> moved to New York in 1974 and quickly became involved in a vital circle of artists based around the St. Marks’ Poetry Project. Myles’ work is widely recognized as an exemplar of first-person writing, owing to their eye for the irreverent power of the slapdash and mundane, how a swab of peanut butter or coffee cup rings evoke keen truths of being and appetite. Myles is the author of queer canon texts <em>Chelsea Girls</em> (1994) and <em>Cool for You</em> (2000), and recently, the literary anthology, <em>Pathetic Literature</em> (2022).</p>
          </div>
          <div className='productMetadata'>
            <div>Special Edition</div>
            <div>Spring 2026</div>
            <div>ISBN 979-8-9956410-0-1</div>
            <div>4.125 x 2.75 inches</div>
            <div>98 Pages</div>
          </div>
        </div>
      </div>
    </div>
  </div>)

}